import React, { useState } from 'react';
import { Type } from 'lucide-react';
import type { SystemSettings } from '../../types';
import type { PromotionPresentationData } from '../../types/promotion';
import PromotionExperience from './PromotionExperience';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

/** 공개 페이지와 권한 있는 미리보기가 공유하는 고객 화면이다. */
export default function PromotionPublicContent({ promotion, hideElements, systemSettings }: {
  promotion: PromotionPresentationData;
  hideElements?: string | null;
  systemSettings: Partial<SystemSettings> | null;
}) {
  const [textSize, setTextSize] = useState<'normal' | 'large' | 'xlarge'>('normal');
  const [controlsOpen, setControlsOpen] = useState(false);
  return <div className={`promotion-public-view promotion-text--${textSize}`}>
    <PromotionExperience promotion={promotion} hideElements={hideElements} systemSettings={systemSettings} textSize={textSize} textControls={<div className="promotion-text-controls">
      <span>* 글자크기를 조절해보세요</span>
      <Popover open={controlsOpen} onOpenChange={setControlsOpen}>
        <PopoverTrigger asChild><button type="button" className="promotion-share-button"><Type aria-hidden="true" size={16} />글자 크기 조절</button></PopoverTrigger>
        <PopoverContent align="end" collisionPadding={12} className="promotion-theme promotion-text-options" aria-label="글자 크기 선택">
        {(['normal', 'large', 'xlarge'] as const).map((size, index) => <button key={size} type="button"
          onClick={() => { setTextSize(size); setControlsOpen(false); }} className="promotion-size-button" aria-pressed={textSize === size}>
          {['보통 (15px)', '크게 (18px)', '더 크게 (20px)'][index]}
        </button>)}
        </PopoverContent>
      </Popover>
    </div>} />
  </div>;
}
